import testService from "services/testService";

export const transformCandidateData = (candidate) => {
  if (!candidate) {
    return {
      nombreCompleto: "No hay candidato seleccionado",
      identificacion: "-",
      edad: "-",
      profesion: "-",
      cargoAplicado: "-",
      fechaEvaluacion: "-",
      email: "-"
    };
  }

  return {
    nombreCompleto: candidate.nombre_completo || "No disponible",
    identificacion: candidate.documento || "No disponible",
    edad: candidate.edad ? `${candidate.edad} años` : "No disponible",
    profesion: candidate.nivel_educativo || "No disponible",
    cargoAplicado: candidate.cargo_aplicado || "No disponible",
    fechaEvaluacion: new Date().toLocaleDateString('es-ES', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    }),
    email: candidate.email || "No disponible"
  };
};

export const calculatePsychologicalIndicators = (valuesData) => {
  if (!valuesData?.success || !valuesData?.data?.[0]?.data?.[0]?.respuestas) {
    return {
      tendenciaCorrupcion: "intermedio",
      scoreCorrupcion: 5,
      nivelMoralidad: "intermedio",
      descripcionMoralidad: "No hay suficientes datos para evaluar"
    };
  }

  const scores = testService.procesarPuntajesTestValores(valuesData);
  const corruptionScore = scores["Tendencia a la Corrupción"] || 0;
  const totalPossibleScore = 40; // 10 preguntas * 4 puntos máximo

  // Calcular porcentaje de tendencia a la corrupción
  const corruptionPercentage = (corruptionScore / totalPossibleScore) * 100;

  let tendenciaCorrupcion = "bajo";
  let nivelMoralidad = "alto";
  let descripcionMoralidad = "Candidato con alta integridad moral y ética";

  if (corruptionPercentage > 60) {
    tendenciaCorrupcion = "alto";
    nivelMoralidad = "bajo";
    descripcionMoralidad = "Comportamiento problemático que podría poner en riesgo la integridad de la empresa";
  } else if (corruptionPercentage > 30) {
    tendenciaCorrupcion = "intermedio";
    nivelMoralidad = "intermedio";
    descripcionMoralidad = "Candidato con comportamiento moderado, requiere seguimiento";
  }

  return {
    tendenciaCorrupcion,
    scoreCorrupcion: Math.round(corruptionScore / 4), // Convertir a escala 1-10
    nivelMoralidad,
    descripcionMoralidad
  };
};

export const filterCandidates = (candidates, searchTerm) => {
  if (!searchTerm) {
    return candidates;
  }
  
  const lowercasedSearchTerm = searchTerm.toLowerCase();
  return candidates.filter((candidate) => {
    const fieldContains = (field) => {
      return field && typeof field === 'string' && field.toLowerCase().includes(lowercasedSearchTerm);
    };
    
    const matchNombre = fieldContains(candidate.nombre_completo);
    const matchDocumento = fieldContains(candidate.documento?.toString());
    const matchEmail = fieldContains(candidate.email);
    const matchGenero = fieldContains(candidate.genero);
    const matchCargoAplicado = fieldContains(candidate.cargo_aplicado);
    
    return matchNombre || matchDocumento || matchEmail || matchGenero || matchCargoAplicado;
  });
};

export const paginateData = (data, currentPage, itemsPerPage) => {
  const totalItems = data.length;
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  const paginatedData = data.slice(start, end);

  return {
    data: paginatedData,
    totalItems,
    totalPages: Math.ceil(totalItems / itemsPerPage),
    currentPage,
    hasNextPage: currentPage < Math.ceil(totalItems / itemsPerPage),
    hasPrevPage: currentPage > 1
  };
};